module.exports = __webpack_public_path__ + "static/media/instagram.f10db4e9.svg";